<section *ngIf="!hideBanner(company)" class="d-md-block d-none cover-image" [style.backgroundImage]="getBackground(company?.coover)"></section>
<nav class="d-md-none d-block">
    <div *ngIf="modal">
        <div class="modal-custom">
            <div class="float-right">
                <span (click)="closeModal()" class="close-btn">&times;</span>
            </div>
            <app-sidebar (CloseModal)="closeModal()" [company]="company" [vacancyPosition]="mobilePosition" [mobile]="true"></app-sidebar>
        </div>
    </div>
    <div id="headerMenu" [style.background]="company?.landingPage?.colors?.mainColor" class="m-b-20">
        <div class="d-flex justify-center" (click)="openModal()">
            <div>
                <img *ngIf="company?.landingPage?.colors?.mainColor === null" class="toggle-menu img-modal" src="assets/images/icons/menu-gray.svg" alt="">
                <img *ngIf="company?.landingPage?.colors?.mainColor" class="toggle-menu " src="assets/images/icons/menu.svg" alt="">
            </div>
            <p *ngIf="company?.landingPage?.colors?.mainColor === null" class="text-center" class="menu-modal">ENCONTRAR VAGAS</p>
            <p *ngIf="company?.landingPage?.colors?.mainColor" class="text-center">ENCONTRAR VAGAS</p>
        </div>
    </div>
</nav>
